import { defineComponent as _defineComponent } from 'vue'
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import Toggle from "@/components/bootstrap/Toggle.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {debounce} from "@/utils/Helpers";
import {Allergens} from "@/models/NutritionLabels/Allergens";
import {computed, inject, ref, watch} from "vue";
import {splitLanguages} from "@/models/NutritionLabels/v2/Helpers";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";

type AllergensConfigurationProps = {
  value: Allergens[],
  language: keyof typeof LabelLanguage,
  mayContainText: string[][]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AllergensConfiguration',
  props: {
    value: null,
    language: null,
    mayContainText: null
  },
  emits: ["fetch-preview", "update:value", "update:mayContainText"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: Allergens[],
  language: keyof typeof LabelLanguage,
  mayContainText: string[][]
};

const fetchPreview: () => void = inject("bopFetchPreview");



const translations = useTranslations();
const iterableAllergens = computed(() => Object.keys(Allergens).filter((key) => isNaN(Number(key))));
const languageHeaders = computed(() => {
  return splitLanguages(LabelLanguage[props.language]).map((l) => translations.value.get(LabelLanguage[l]));
});

const isBilingual = computed(() => languageHeaders.value.length > 1);
const model = ref(props.value.map((a) => a.toString()));
const mayContainText = ref<string[][]>(props.mayContainText ?? []);

watch(
  () => props.value,
  (newVal) => {
    model.value = newVal.map((a) => a.toString());
  },
  { deep: true, immediate: true }
);

watch(
  () => props.mayContainText,
  (newVal) => {
    mayContainText.value = newVal ?? [];
  },
  { deep: true, immediate: true }
);

const mayContainError = computed(() => {
  if (!isBilingual.value) return null;

  const lang1 = mayContainText.value?.[0] ?? [];
  const lang2 = mayContainText.value?.[1] ?? [];

  if (lang1.length !== lang2.length) {
    return translations.value.get("error_missing_translation");
  }

  return null;
});

function onAllergenToggled(allergen: string, isChecked: boolean) {
  if (isChecked) {
    model.value.push(allergen);
  }

  else {
    model.value = model.value.filter((x) => x != allergen);
  }

  emit('update:value', model.value.map((a) => Allergens[a]));
  debouncedFetchPreview();
}

function onTagAdded() {
  emit("update:mayContainText", mayContainText.value);

  if (!mayContainError.value) {
    debouncedFetchPreview();
  }
}

function debouncedFetchPreview() {
  debounce(fetchPreview, 1000, "back-of-package-config-label-update");
}

return { __sfc: true,fetchPreview, props, emit, translations, iterableAllergens, languageHeaders, isBilingual, model, mayContainText, mayContainError, onAllergenToggled, onTagAdded, debouncedFetchPreview, CollapsableCard, Toggle, Allergens }
}

})